import { render, staticRenderFns } from "./MediaStorageTable.vue?vue&type=template&id=2a3c2356&scoped=true&"
import script from "./MediaStorageTable.vue?vue&type=script&lang=js&"
export * from "./MediaStorageTable.vue?vue&type=script&lang=js&"
import style0 from "./MediaStorageTable.vue?vue&type=style&index=0&id=2a3c2356&prod&lang=scss&"
import style1 from "./MediaStorageTable.vue?vue&type=style&index=1&id=2a3c2356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c2356",
  null
  
)

export default component.exports